module.exports = __webpack_public_path__ + "f5306f3b9cf23455a001cf24a6f307d3.png";